import { useMemo } from 'react';

import { FraudRiskFileAttribute } from '~/core/shared/types';
import { getRiskConfig } from '../../logic/getRiskConfig';

export const useRiskConfig = (
  fraudRisk?: FraudRiskFileAttribute,
): ReturnType<typeof getRiskConfig> => {
  const riskConfig = useMemo(() => getRiskConfig(fraudRisk), [fraudRisk]);

  return riskConfig;
};
